import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ApiService } from '../../../../services/api.service';
import { DocumentoAccredito, Evento, Spettacolo } from '../../../../shared/interface';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { RadioButtonClickEvent } from 'primeng/radiobutton';

@Component({
  selector: 'app-accredito-backoffice',
  templateUrl: './accredito-backoffice.component.html',
  styleUrl: './accredito-backoffice.component.css'
})
export class AccreditoBackofficeComponent implements OnInit {

  constructor (private apiService: ApiService, private confirmationService: ConfirmationService, private router: Router, private route: ActivatedRoute, private datePipe: DatePipe, private cdr: ChangeDetectorRef) {}

  @Input() evento?: Evento;
  @Input() spettacolo?: Spettacolo;

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;  

  documenti: DocumentoAccredito[] = [];
  agibilita_inps: DocumentoAccredito[] = [];
  schede_tecniche: DocumentoAccredito[] = [];
  montaggio: DocumentoAccredito[] = [];

  openSections: Record<string, boolean> = {
    dossier: true,
    info: false,
    personale: false,
    subappalti: false,
    impianti: false,
    mezzi: false,
  };

  impiantiOptions = [
    { id: 'impianto1', value: 'impianti_elettrici', label: 'Impianti Elettrici', control: 'impianti_elettrici_file' },
    { id: 'impianto_luci', value: 'impianti_luci', label: 'Impianti Luci', control: 'impianti_luci_file' },
    { id: 'impianto2', value: 'impianti_audio', label: 'Impianti Audio', control: 'impianti_audio_file' },
    { id: 'impianto3', value: 'impianti_video', label: 'Impianti Video', control: 'impianti_video_file' },
    { id: 'impianto4', value: 'effetti_scenici', label: 'Effetti Scenici', control: 'effetti_scenici_file' },
    { id: 'impianto5', value: 'macchina_fumo', label: 'Macchina del fumo', control: 'macchina_fumo_file' },
    { id: 'impianto6', value: 'carichi_sospesi', label: 'Carichi Sospesi', control: 'carichi_sospesi_file' },
  ];

  pos: boolean = false;
  attivita_rischio: boolean = true;
  certificazioni_impianti: boolean = false;  
  certificazione_impianti: boolean = true;  
  
  loading: boolean = false;

  formEvento!: FormGroup;

  ngOnInit(): void {

    this.formEvento = new FormGroup({
      evento: new FormControl(null, Validators.required),
      dal_al: new FormControl(null, Validators.required),            
      obbligatorieta: new FormControl(null, Validators.required),      
      blocco: new FormControl(null, Validators.required),            
      durata: new FormControl(null, Validators.required),
      intervallo: new FormControl('No', Validators.required),
      foto: new FormControl('No', Validators.required),
      merchandising: new FormControl('No', Validators.required),
      merchandising_email: new FormControl(null),      
      firmacopie: new FormControl('No', Validators.required),
      firmacopie_email: new FormControl(null),   
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null, Validators.required),
      sede: new FormControl(null, Validators.required),      
      anagrafica: new FormControl(null, Validators.required),      
      email: new FormControl(null, [Validators.required, Validators.email]),
      telefono: new FormControl(null, [Validators.required, Validators.pattern('^(?=[0-9]*$)(?:.{9}|.{10})$')]),      
      visura_camerale: new FormControl(null, Validators.required),      
      duvri_file: new FormControl(null, Validators.required),
      agibilita_inps_file: new FormControl(null),
      scheda_tecnica: new FormControl(null),
      pass_compagnia: new FormControl(null, Validators.required),
      pass_compagnia_file: new FormControl(null),
      attivita: new FormControl(null, Validators.required),      
      montaggio: new FormControl(null),
      montaggio_file: new FormControl(null),
      certificazione_impianti: new FormControl(null, Validators.required),
      impianti_elettrici_file: new FormControl(null),
      impianti_luci_file: new FormControl(null),
      impianti_audio_file: new FormControl(null),
      impianti_video_file: new FormControl(null),
      effetti_scenici_file: new FormControl(null),
      macchina_fumo_file: new FormControl(null),
      carichi_sospesi_file: new FormControl(null),            
      certificazione_impianti_extra: new FormControl(null),            
      certificazione_impianti_extra_file: new FormControl(null),             
    })

    this.getEvento();
      
  }

  toggleSec(key: string) {
    this.openSections[key] = !this.openSections[key];
  }

  getEvento() {    

    this.formEvento.patchValue({
      evento: this.evento?.evento,
      dal_al: [new Date(this.evento!.dal), new Date(this.evento!.al)],
      obbligatorieta: this.evento?.obbligatorieta ? ['Obbligatorieta'] : null,
      blocco: this.evento?.blocco ? this.evento?.blocco : null,
      attivita: this.evento?.attivita ? this.evento?.attivita.split(',') : null,
      durata: (this.evento?.durata || 0) > 0 ? this.evento?.durata : null,
      intervallo: this.evento?.intervallo ? 'Si' : 'No',
      foto: this.evento?.foto ? 'Si' : 'No',
      merchandising: this.evento?.merchandising ? 'Si' : 'No',
      merchandising_email: this.evento?.merchandising_email,
      firmacopie: this.evento?.firmacopie ? 'Si' : 'No',
      firmacopie_email: this.evento?.firmacopie_email,
      montaggio: this.evento?.montaggio ? ['montaggio'] : null,
      certificazione_impianti: (this.evento?.certificazione_impianti || '').length > 0 ? this.evento?.certificazione_impianti.split(',') : null,
      certificazione_impianti_extra: this.evento?.certificazione_impianti_extra,
      ragione_sociale: this.evento?.ragione_sociale,
      piva: this.evento?.piva,
      sede: this.evento?.sede,
      anagrafica: this.evento?.anagrafica,
      email: this.evento?.email,
      telefono: this.evento?.telefono,
      visura_camerale: this.evento?.visura_camerale,
      duvri: this.evento?.duvri,
      pass_compagnia: this.evento?.check_pass ? 'Si' : 'No',
      pass_compagnia_file: this.evento?.pass,
    });

    this.documenti = [...this.evento?.documenti || []].filter(documento =>  !documento.id_personale && (documento.tipo != 'inps' && documento.tipo != 'scheda_tecnica' && documento.tipo != 'montaggio'));
    this.agibilita_inps = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'inps');
    this.schede_tecniche = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'scheda_tecnica');
    this.montaggio = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'montaggio');
    
    this.getData();    
    this.onCertificazioni();  

    this.loading = false;     
    this.cdr.detectChanges();           
  }

  getData() {

    this.apiService.personaleEventoChanged.subscribe({
      next: (data) => this.evento!.personale = [...data || []],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

    this.apiService.subappaltiEventoChanged.subscribe({
      next: (data) => this.evento!.subappalti = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

    this.apiService.mezziTrasportoEventoChanged.subscribe({
      next: (data) => this.evento!.mezzi = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

    this.apiService.documentiEventoChanged.subscribe({
      next: (data) => {
        this.evento!.documenti = [...data.filter(doc => !doc.id_personale)]
        this.documenti = [...this.evento?.documenti || []].filter(documento =>  !documento.id_personale && (documento.tipo != 'inps' && documento.tipo != 'scheda_tecnica' && documento.tipo != 'montaggio'));
        this.agibilita_inps = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'inps');
        this.schede_tecniche = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'scheda_tecnica');
        this.montaggio = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'montaggio');
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

  }

  onCertificazioni() {
    let data = this.evento?.certificazione_impianti ? this.evento?.certificazione_impianti.split(',') : [];
    if (data.length > 0) {
      if (data.includes('altro')) {
        this.certificazioni_impianti = true;
        this.certificazione_impianti = true;
        this.formEvento.get('certificazione_impianti_extra')?.setValidators(Validators.required);
      } else if (data.includes('non_presenti')) {
        this.certificazioni_impianti = false;
        this.certificazione_impianti = false;
      } else {
        this.certificazioni_impianti = true;
        this.certificazione_impianti = true;
      }
    } else {
      this.certificazioni_impianti = false;
      this.certificazione_impianti = true;
    }

    data.filter(certificazione => certificazione != 'altro' && certificazione != 'non_presenti').map(certificazione => {
      if ((this.evento?.documenti || []).filter(doc => doc.tipo == certificazione).length <= 0)
        this.formEvento.get(certificazione + '_file')?.setValidators(Validators.required)

      this.formEvento.get(certificazione + '_file')?.updateValueAndValidity();
    })

    this.formEvento.get('certificazione_impianti_extra_file')?.updateValueAndValidity();

  }

  hasImpianto(value: string): boolean {
    return (this.formEvento.get('certificazione_impianti')?.value || []).includes(value);
  }

  docsByTipo(tipo: string): DocumentoAccredito[] {
    return (this.documenti || []).filter(d => d.tipo === tipo);
  }

  setImpianto(value: string, answer: string) {
    let current: string[] = [...(this.formEvento.get('certificazione_impianti')?.value || [])];
    const si = answer === 'Si';

    if (si) {
      if (value === 'non_presenti') {
        current.forEach(v => {
          if (v !== 'non_presenti' && v !== 'altro') {
            this.formEvento.get(v + '_file')?.removeValidators(Validators.required);
            this.formEvento.get(v + '_file')?.updateValueAndValidity();
          }
        });
        current = ['non_presenti'];
        this.formEvento.get('certificazione_impianti_extra')?.removeValidators(Validators.required);
        this.certificazione_impianti = false;
        this.certificazioni_impianti = false;
      } else {
        current = current.filter(v => v !== 'non_presenti');
        if (!current.includes(value)) current.push(value);
        this.certificazione_impianti = true;
        this.certificazioni_impianti = true;
        if (value === 'altro') {
          this.formEvento.get('certificazione_impianti_extra')?.setValidators(Validators.required);
        } else if ((this.evento?.documenti || []).filter(doc => doc.tipo == value).length <= 0) {
          this.formEvento.get(value + '_file')?.setValidators(Validators.required);
        }
      }
    } else {
      current = current.filter(v => v !== value);
      if (value === 'altro') {
        this.formEvento.get('certificazione_impianti_extra')?.removeValidators(Validators.required);
      } else if (value !== 'non_presenti') {
        this.formEvento.get(value + '_file')?.removeValidators(Validators.required);
      }
      if (value === 'non_presenti') {
        this.certificazione_impianti = true;
      }
    }

    this.formEvento.patchValue({ certificazione_impianti: current.length ? current : null });
    this.formEvento.get('certificazione_impianti')?.markAsDirty();
    this.formEvento.get(value + '_file')?.updateValueAndValidity();
    this.formEvento.get('certificazione_impianti_extra')?.updateValueAndValidity();
    this.formEvento.get('certificazione_impianti_extra_file')?.updateValueAndValidity();
  }

  onCertificazioneImpianti(event: any) {
    if (event.checked.length > 0) {
      if (event.checked.includes('altro')) {
        this.certificazioni_impianti = true;
        this.certificazione_impianti = true;
        this.formEvento.get('certificazione_impianti_extra')?.setValidators(Validators.required);
      } else if (event.checked.includes('non_presenti')) {
        this.certificazioni_impianti = false;
        this.certificazione_impianti = false;
      } else {
        this.certificazioni_impianti = true;
        this.certificazione_impianti = true;
      }
    } else {
      this.certificazioni_impianti = false;
      this.certificazione_impianti = true;
    }

    if (event.checked.includes(event.originalEvent?.target?.defaultValue)) {
      if ((this.evento?.documenti || []).filter(doc => doc.tipo == event.originalEvent?.target?.defaultValue).length <= 0) {
        this.formEvento.get(event.originalEvent?.target?.defaultValue + '_file')?.setValidators(Validators.required)
      }
    } else {
      this.formEvento.get(event.originalEvent?.target?.defaultValue + '_file')?.removeValidators(Validators.required)
    }

    this.formEvento.get(event.originalEvent?.target?.defaultValue + '_file')?.updateValueAndValidity();
    this.formEvento.get('certificazione_impianti_extra_file')?.updateValueAndValidity();

  } 

  onPassCompagnia(pass: string) {
    if (pass == 'Si') {                        
      this.formEvento.get('pass_compagnia_file')?.setValidators(Validators.required);        
    } else {      
      this.formEvento.get('pass_compagnia_file')?.removeValidators(Validators.required);
    }        
  }

  onMerchandising(merchandising: RadioButtonClickEvent) {    
    if (merchandising.value == 'Si') {                        
      this.formEvento.get('merchandising_email')?.setValidators(Validators.required);        
    } else {      
      this.formEvento.get('merchandising_email')?.removeValidators(Validators.required);
    }    
  }

  onFirmacopie(firmacopie: RadioButtonClickEvent) {    
    if (firmacopie.value == 'Si') {                        
      this.formEvento.get('firmacopie_email')?.setValidators(Validators.required);        
    } else {      
      this.formEvento.get('firmacopie_email')?.removeValidators(Validators.required);
    }    
  }

  onDeletePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare l'evento?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteEvento(this.evento!.id).subscribe({
          next: (data) => this.apiService.setEventi(),
          error: (err) => this.apiService.message('error','Errore',err.error.message.message),
          complete: () => {            
            this.confirmationService.close();
            this.apiService.message('success','Eliminazione',"L'evento è stato eliminato con successo");
          },
        });
      },
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    let evento = new FormData();

    evento.append('evento', this.formEvento.get('evento')?.value || '');
    evento.append('dal', this.formEvento.get('dal_al')?.value ? this.datePipe.transform(this.formEvento.get('dal_al')?.value[0],'yyyy-MM-dd', ) || '' : '');
    evento.append('al', this.formEvento.get('dal_al')?.value ? this.datePipe.transform(this.formEvento.get('dal_al')?.value[1],'yyyy-MM-dd') || '' : '');
    evento.append('durata', this.formEvento.get('durata')?.value || 0);
    evento.append('intervallo', this.formEvento.get('intervallo')?.value == 'Si' ? "true" : "false");
    evento.append('foto', this.formEvento.get('foto')?.value == 'Si' ? "true" : "false");
    evento.append('merchandising', this.formEvento.get('merchandising')?.value == 'Si' ? "true" : "false");
    evento.append('merchandising_email', this.formEvento.get('merchandising_email')?.value || '');
    evento.append('firmacopie', this.formEvento.get('firmacopie')?.value == 'Si' ? "true" : "false");    
    evento.append('firmacopie_email', this.formEvento.get('firmacopie_email')?.value || '');
    evento.append('obbligatorieta', this.formEvento.get('obbligatorieta')?.value ? (this.formEvento.get('obbligatorieta')?.value.length > 0 ? 'true' : '') : '');    
    evento.append('blocco', this.formEvento.get('blocco')?.value || 72);        
    evento.append('ragione_sociale', this.formEvento.get('ragione_sociale')?.value || '');
    evento.append('piva', this.formEvento.get('piva')?.value || '');
    evento.append('sede', this.formEvento.get('sede')?.value || '');
    evento.append("anagrafica", this.formEvento.get('anagrafica')?.value);
    evento.append("email", this.formEvento.get('email')?.value);
    evento.append("telefono", this.formEvento.get('telefono')?.value);
    evento.append("visura_camerale", this.formEvento.get('visura_camerale')?.value || '');    
    evento.append("duvri_file", this.formEvento.get('duvri_file')?.value || '');        
    (this.formEvento.get('scheda_tecnica')?.value || []).map((file: File) => evento.append("scheda_tecnica", file || ''));    
    evento.append("pass", this.formEvento.get('pass_compagnia')?.value == 'Si' ? "true" : "false");
    evento.append("pass_compagnia_file", this.formEvento.get('pass_compagnia_file')?.value || '');
    (this.formEvento.get('agibilita_inps_file')?.value || []).map((file: File) => evento.append("agibilita_inps_file", file || ''));    
    evento.append('attivita', this.formEvento.get('attivita')?.value ? this.formEvento.get('attivita')?.value.join(',') : '');    
    evento.append('montaggio', this.formEvento.get('montaggio')?.value ? (this.formEvento.get('montaggio')?.value.length > 0 ? "true" : "false") : "false");    
    (this.formEvento.get('montaggio_file')?.value || []).map((file: File) => evento.append("montaggio_file", file || ''));    
    evento.append("certificazione_impianti", this.formEvento.get('certificazione_impianti')?.value ? this.formEvento.get('certificazione_impianti')?.value.join(',') : '');    
    (this.formEvento.get('impianti_elettrici_file')?.value || []).map((file: File) => evento.append("impianti_elettrici_file", file || ''));
    (this.formEvento.get('impianti_luci_file')?.value || []).map((file: File) => evento.append("impianti_luci_file", file || ''));
    (this.formEvento.get('impianti_audio_file')?.value || []).map((file: File) => evento.append("impianti_audio_file", file || ''));
    (this.formEvento.get('impianti_video_file')?.value || []).map((file: File) => evento.append("impianti_video_file", file || ''));
    (this.formEvento.get('effetti_scenici_file')?.value || []).map((file: File) => evento.append("effetti_scenici_file", file || ''));
    (this.formEvento.get('macchina_fumo_file')?.value || []).map((file: File) => evento.append("macchina_fumo_file", file || ''));
    (this.formEvento.get('carichi_sospesi_file')?.value || []).map((file: File) => evento.append("carichi_sospesi_file", file || ''));    
    evento.append("certificazione_impianti_extra", this.formEvento.get('certificazione_impianti_extra')?.value || '');    
    (this.formEvento.get('certificazione_impianti_extra_file')?.value || []).map((file: File) => evento.append("certificazione_impianti_extra_file", file || ''));
    
    this.apiService.updateEvento(evento, this.evento!.id).subscribe({      
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {        
        if (this.spettacolo)
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => { this.router.navigate(['/backoffice/spettacoli/' + this.spettacolo!.id + '/area-compagnia']); });
        else
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => { this.router.navigate(['/backoffice/area-compagnie/' + this.evento!.id]); });

        this.apiService.message('success', 'Modifica', 'Evento modificato con successo!');        
      },
    });
  }

  get visuraScadenzaValue(): string {
    if (!this.evento?.visura_scadenza) return '';
    const d = new Date(this.evento.visura_scadenza);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  }

  get isVisuraScaduta(): boolean {
    if (!this.evento?.visura_scadenza) return false;
    const d = new Date(this.evento.visura_scadenza);
    if (Number.isNaN(d.getTime())) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);
    return d.getTime() < today.getTime();
  }

  onVisuraScadenza(event: Event) {
    if (!this.evento?.id) return;
    const value = (event.target as HTMLInputElement).value || null;
    this.apiService.updateVisuraScadenza(this.evento.id, value).subscribe({
      next: () => {
        this.evento!.visura_scadenza = value;
        this.apiService.message('success', 'Scadenza', value ? 'Scadenza visura aggiornata' : 'Scadenza visura rimossa');
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Aggiornamento fallito'),
    });
  }

}
